import './main.js';
import { initMoviesPage } from './ts/features/homeMoviesController.js';

initMoviesPage();
